const cacheH5RouteStore = () => {
  const cacheNameList = ref([]);
  const addCacheName = (name) => {
    // 检查是否已存在
    if (!cacheNameList.value.includes(name)) {
        console.log('添加缓存',name);
      cacheNameList.value.push(name);
    }
  };
  const removeCacheName = (name) => {
    const index = cacheNameList.value.indexOf(name);
    if (index !== -1) {
      cacheNameList.value.splice(index, 1);
    }
  };
  return {
    cacheNameList,
    addCacheName,
    removeCacheName,
  };
};

export const useCacheH5RouteStore = defineStore("cacheH5RouteStore", cacheH5RouteStore);
